const pageTitle = {
  Shopback: 'SHOPBACK',
  Apps: '应用程式',
  'App Store': '应用程式商店',
};

export default pageTitle;
